export function undefinedToNull(value) {
  if (Array.isArray(value)) {
    return value.map(undefinedToNull);
  }

  if (value !== null && typeof value === "object") {
    return Object.entries(value).reduce(
      (acc, [k, v]) => ({
        ...acc,
        [k]: undefinedToNull(v),
      }),
      {}
    );
  }

  return typeof value === "undefined" ? null : value;
}
